import { gql } from '@apollo/client';

export const GET_TMS_ROUTE_LISTING = gql`
    query GetTmsRouteListing($filter: TmsRouteFiltersInput, $pageRequest: PageRequestTypeInput) {
        getTmsRouteListing(filters: $filter, pageRequest: $pageRequest) {
            content {
                id
                routeName
                routeType
                businessType
                routeCode
                startWarehouseId
                endWarehouseId
                plannedTotalHours
                plannedTotalMiles
                carrierId
                carrierName
                carrierSourceType
                waypointIds
                startSortingCode
                endSortingCode
                waypointSortingCodes
                status
                createdAt
                updatedAt
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
`;

export const GET_TMS_ROUTE_BY_ID = gql`
    query GetTmsRouteById($id: ID!) {
        getTmsRouteById(id: $id) {
            id
            routeName
            routeType
            businessType
            routeCode
            startWarehouseId
            endWarehouseId
            plannedTotalHours
            plannedTotalMiles
            carrierId
            status
            createdAt
            updatedAt
        }
    }
`;

export const GET_TMS_ROUTE_WITH_CARRIER_INFO_BY_ID = gql`
    query GetTmsRouteWithCarrierInfoById($id: ID!) {
        getTmsRouteWithCarrierInfoById(id: $id) {
            id
            routeName
            routeType
            businessType
            routeCode
            startWarehouseId
            endWarehouseId
            plannedTotalHours
            plannedTotalMiles
            carrierId
            carrierName
            status
            carrierSourceType
            waypointIds
            createdAt
            updatedAt
        }
    }
`;

export const GET_TMS_ROUTE_WAYPOINTS_WITH_SORTING_CODE_BY_ROUTE_ID = gql`
    query GetTmsRouteWaypointsWithSortingCodeByRouteId($routeId: Long!) {
        getTmsRouteWaypointsWithSortingCodeByRouteId(routeId: $routeId) {
            routeBusinessType
            waypoints {
                id
                routeId
                waypointId
                extWaypointId
                waypointOrder
                waypointType
                waypointStatus
                travelTime
                dwellTime
                distance
                waypointSortingCode
                waypointTimezone
                waypointTimezoneOffset
            }
        }
    }
`;

export const GET_TMS_ROUTES_FOR_SEARCH_SELECT = gql`
    query GetTmsRoutesForSearchSelect($routeName: String, $warehouseId: Long, $waypointTypes: [Int!]!, $status: Int, $routeType: Int, $businessType: Int) {
        getTmsRoutesForSearchSelect(
            routeName: $routeName
            warehouseId: $warehouseId
            waypointTypes: $waypointTypes
            status: $status
            routeType: $routeType
            businessType: $businessType
        ) {
            id
            routeName
            routeType
            businessType
            startWarehouseId
            carrierId
            carrierName
            carrierSourceType
        }
    }
`;

export interface TmsRouteType {
    id: string;
    routeName: string;
    routeCode?: string;
    routeType: number;
    businessType?: number;
    startWarehouseId: number;
    endWarehouseId: number | null;
    plannedTotalHours: number;
    plannedTotalMiles: number;
    carrierId: number;
    carrierName?: string;
    carrierSourceType?: number | null;
    waypointIds?: number[];
    startSortingCode?: string;
    endSortingCode?: string;
    waypointSortingCodes?: string[];
    status: number;
    createdAt: string;
    updatedAt: string;
}

export interface TmsRouteFiltersInput {
    routeId?: number;
    routeName?: string;
    routeType?: number;
    startWarehouseId?: number;
    endWarehouseId?: number;
    waypointWarehouseId?: number;
    // 归属仓（当前 Hub）：与 startWarehouseId 同为 start_warehouse_id 列的过滤条件，后端两者 AND，将结果圈定在当前 Hub 内
    belongingWarehouseId?: number;
    carrierId?: number;
    carrierName?: string;
    status?: number;
}

export interface TmsRouteListingResponse {
    getTmsRouteListing: TmsRouteListingResponseType;
}

export interface TmsRouteListingResponseType {
    content: TmsRouteType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface TmsRouteWaypointType {
    id: string;
    routeId: number;
    waypointId: number;
    extWaypointId?: number | null;
    waypointOrder: number;
    waypointType: number;
    waypointStatus: number;
    travelTime: number;
    dwellTime: number;
    distance: number;
    waypointSortingCode?: string;
    waypointTimezone?: string;
    waypointTimezoneOffset?: number;
}

/** 含路线业务类型的途经点查询响应（与 GET_TMS_ROUTE_WAYPOINTS_WITH_SORTING_CODE_BY_ROUTE_ID 对应） */
export interface GetTmsRouteWaypointsWithSortingCodeByRouteIdResponse {
    getTmsRouteWaypointsWithSortingCodeByRouteId: {
        routeBusinessType: number | null;
        waypoints: TmsRouteWaypointType[];
    };
}

export interface GetTmsRouteByIdResponse {
    getTmsRouteById: TmsRouteType;
    waypoints?: TmsRouteWaypointType[];
}

export interface TmsRouteWithCarrierInfoType extends TmsRouteType {
    carrierSourceType?: number | null;
}

export interface GetTmsRouteWithCarrierInfoByIdResponse {
    getTmsRouteWithCarrierInfoById: TmsRouteWithCarrierInfoType;
}

export interface GetTmsRoutesForSearchSelectResponse {
    getTmsRoutesForSearchSelect: Array<{
        id: string;
        routeName: string;
        routeType?: number;
        businessType?: number;
        startWarehouseId: number;
        carrierId: number;
        carrierName?: string | null;
        carrierSourceType?: number | null;
    }>;
}

